import YoutubeVideo from './YoutubeVideo';

export default YoutubeVideo;
